import { CountryCode } from 'interfaces/Country'
import { Attributes } from 'lib/hooks/useWebConfig/useWebConfigAttributes'

export type WebsiteConfigFlagParams =
    | 'showExperiment1'
    | 'showWebAppEntrypoint'
    | 'showPreventAccessDialog'
    | 'showEXP2'
    | 'showOnboardingUserAgeInput'

export type WebsiteConfigFlag = {
    config: {
        [x in WebsiteConfigFlagParams]?: boolean
    }
    isActive: (attributes: Attributes) => boolean
}

export const websiteConfigFlags: WebsiteConfigFlag[] = [
    {
        config: {
            showOnboardingUserAgeInput: true,
        },
        isActive: (attributes: Attributes) => {
            return attributes.countryCode === CountryCode.UnitedStates
        },
    },
    {
        config: {
            showPreventAccessDialog: true,
        },
        isActive: (attributes: Attributes) => {
            return true
        },
    },
]
